import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { Paginator } from "primereact/paginator";
import { Ripple } from "primereact/ripple";
import CreateModal from "./CreateModal";
import UpdateModal from "./UpdateModal";
import { TitleContext } from "../../../Context/TitleContext";
import { API_URL, useAxios, rowsPerPageOptions } from "../../../utils/const";
import { Toaster } from "react-hot-toast";
import { DeleteModal } from "./DeleteModal";
import excelJS from "exceljs";
import { saveAs } from "file-saver";
import { ImportMahasiswaModal } from "./ImportMahasiswaModal";
import { ImportDosenModal } from "./ImportDosenModal";
import { useToast } from "../../../Context/ToastContext";

const Users = () => {
  const { setTitle } = useContext(TitleContext);
  const { setToastObj } = useToast();
  const axiosInstance = useAxios();

  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openImportMahasiswaModal, setOpenImportMahasiswaModal] =
    useState(false);
  const [openImportDosenModal, setOpenImportDosenModal] = useState(false);

  const [users, setUsers] = useState({ users: [], totalRecords: 0 });
  const [userRecords, setUserRecords] = useState([]);
  const [selectedUser, setSelectedUser] = useState([]);
  const [roles, setRoles] = useState([]);

  const [search, setSearch] = useState("");
  const [pagination, setPagination] = useState({ first: 0, rows: 10, page: 0 });
  const [rowPerPage, setRowPerPage] = useState(10);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTitle("USAKTI | Manajemen Pengguna"); // Set judul halaman
  }, [setTitle]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await getUsers();
        await getRoles();
      } catch (error) {
        setToastObj({
          msg: error,
          type: "danger",
        });
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [pagination]);

  function handleRowChange(row) {
    setPagination({ first: 0, rows: row, page: 0 });
  }

  const onPageChange = async (event) => {
    setPagination({ first: event.first, rows: event.rows, page: event.page });
  };

  const toggleOpenCreateModal = () => {
    setOpenCreateModal(true);
  };

  const toggleOpenUpdateModal = (e) => {
    setSelectedUser(e);
    setOpenUpdateModal(true);
  };

  const toggleOpenDeleteModal = (user) => {
    setOpenDeleteModal(true);
    setSelectedUser(user);
  };

  const toggleOpenImportMahasiswaModal = () => {
    setOpenImportMahasiswaModal(true);
  };

  const toggleOpenImportDosenModal = () => {
    setOpenImportDosenModal(true);
  };

  function handleFilter(event) {
    const newData = users.users.filter((row) => {
      return (
        row.nim.toLowerCase().includes(event.target.value.toLowerCase()) ||
        row.name.toLowerCase().includes(event.target.value.toLowerCase()) ||
        row.email.toLowerCase().includes(event.target.value.toLowerCase())
      );
    });
    setUserRecords(newData);
    setSearch(event.target.value);
  }

  const getUsers = async () => {
    const limit = pagination.rows === "All" ? -1 : pagination.rows;

    const response = await axiosInstance.get(
      `${API_URL}/users?search=${search}&page=${
        pagination.page + 1
      }&limit=${limit}`
    );
    setUsers({
      users: response.data.data,
      totalRecords: response.data.totalRecords,
    });
    setUserRecords(response.data.data);
  };

  const getRoles = async () => {
    const response = await axiosInstance.get(`${API_URL}/users/get-roles`);
    setRoles(response.data.data);
  };

  const exportMahasiswaTemplateExcel = async () => {
    const workbook = new excelJS.Workbook();
    const worksheet = workbook.addWorksheet("User Mahasiswa Template Excel");
    worksheet.columns = [
      { header: "NIM", key: "nim", width: 10 },
      { header: "NAMA_MAHASISWA", key: "nama_mahasiswa", width: 10 },
      { header: "EMAIL", key: "email", width: 10 },
    ];

    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true };
    });

    const buf = await workbook.xlsx.writeBuffer();
    saveAs(
      new Blob([buf], { type: "application/octet-stream" }),
      "User Mahasiswa Template Excel.xlsx"
    );
  };

  const exportDosenTemplateExcel = async () => {
    // Create a new workbook
    const workbook = new excelJS.Workbook();
    // New Worksheet
    const worksheet = workbook.addWorksheet("User Dosen Template Excel");
    // Column for data in excel. key must match data key
    worksheet.columns = [
      { header: "NIDN", key: "nidn", width: 10 },
      { header: "NAMA_DOSEN", key: "nama_dosen", width: 10 },
      { header: "EMAIL", key: "email", width: 10 },
    ];

    // Making first line in excel bold
    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true };
    });

    const buf = await workbook.xlsx.writeBuffer();
    saveAs(
      new Blob([buf], { type: "application/octet-stream" }),
      "User Dosen Template Excel.xlsx"
    );
  };

  const paginationTemplate = {
    layout: "PrevPageLink PageLinks NextPageLink ",
    PrevPageLink: (options) => {
      return (
        <button
          type="button"
          className="btn border"
          onClick={options.onClick}
          disabled={options.disabled}
        >
          <span className="p-3">Previous</span>
          <Ripple />
        </button>
      );
    },
    NextPageLink: (options) => {
      return (
        <button
          type="button"
          className="btn border"
          onClick={options.onClick}
          disabled={options.disabled}
        >
          <span className="p-3">Next</span>
          <Ripple />
        </button>
      );
    },
  };

  return loading == false ? (
    <div>
      <Toaster position="top-right" />
      <div className="container">
        <div className="card mb-4">
          <div className="card-body">
            <h1>Pengaturan Pengguna</h1>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Dashboard</Link>
              </li>
              <li className="breadcrumb-item active">Pengaturan Pengguna</li>
            </ol>
          </div>
        </div>

        <div className="card">
          <div className="card-body m-3">
            <div className="row">
              <div
                className="col-md-12 d-flex gap-2"
                style={{ justifyContent: "end" }}
              >
                <Dropdown>
                  <Dropdown.Toggle variant="primary">
                    Export/Import
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={exportMahasiswaTemplateExcel}>
                      Export Template Mahasiswa
                    </Dropdown.Item>
                    <Dropdown.Item onClick={exportDosenTemplateExcel}>
                      Export Template Dosen
                    </Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item onClick={toggleOpenImportMahasiswaModal}>
                      Import Excel Mahasiswa
                    </Dropdown.Item>
                    <Dropdown.Item onClick={toggleOpenImportDosenModal}>
                      Import Excel Dosen
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                <button
                  className="btn btn-success"
                  onClick={toggleOpenCreateModal}
                >
                  + Tambah
                </button>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-4 text-center offset-md-4">
                <h4>Daftar Pengguna</h4>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-md-6">
                <label>Show</label>
                <select
                  value={pagination.rows}
                  onChange={(e) => handleRowChange(e.target.value)}
                  className="form-select form-select-sm d-inline-block w-auto ms-2"
                >
                  {rowsPerPageOptions.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
                <label style={{ marginLeft: "5px" }}>entries</label>
              </div>
              <div className="col-md-6 text-end">
                <label>Search :</label>
                <input
                  type="text"
                  style={{
                    width: "auto",
                    display: "inline-block",
                    marginLeft: "5px",
                  }}
                  className="form-control form-control-sm"
                  onChange={handleFilter}
                />
                <button
                  className="btn btn-primary text-white me-2"
                  style={{ marginLeft: "5px" }}
                  onClick={getUsers}
                >
                  Cari
                </button>
              </div>
            </div>

            <div className="table-responsive">
              {/* Tabel Data Pengguna */}
              <table className="table table-striped mt-3">
                <thead>
                  <tr>
                    <th>NO</th>
                    <th>NIDN/NIM</th>
                    <th>NAMA</th>
                    <th>EMAIL</th>
                    <th>PERAN</th>
                    <th>STATUS</th>
                    <th>AKSI</th>
                  </tr>
                </thead>
                <tbody>
                  {userRecords.map((item, index) => (
                    <tr key={item.id}>
                      <td>{pagination.first + index + 1}</td>
                      <td>{item.nim}</td>
                      <td>{item.name}</td>
                      <td>{item.email}</td>
                      <td>
                        {item.userHasRoles.length > 0
                          ? item.userHasRoles[0].roles.name
                          : "-"}
                      </td>
                      <td>
                        {item.status === 1 ? (
                          <span className="badge text-bg-success">AKTIF</span>
                        ) : (
                          <span className="badge text-bg-danger">
                            TIDAK AKTIF
                          </span>
                        )}
                      </td>
                      <td>
                        <button
                          className="btn btn-warning text-white me-2"
                          onClick={() => toggleOpenUpdateModal(item)}
                        >
                          <i className="fas fa-pen-to-square"></i>
                        </button>
                        <button
                          className="btn btn-danger text-white"
                          onClick={() => toggleOpenDeleteModal(item)}
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Paginator dari PrimeReact */}
            <div className="row">
              <div className="col-md-6 d-flex align-items-center h-100">
                <p>
                  Showing {pagination.first + 1} to{" "}
                  {pagination.rows > users.totalRecords
                    ? users.totalRecords
                    : pagination.rows}{" "}
                  of {users.totalRecords} entries
                </p>
              </div>
              <div className="col-md-6">
                <Paginator
                  first={pagination.first}
                  rows={pagination.rows === "All" ? users.totalRecords : pagination.rows}
                  totalRecords={users.totalRecords}
                  onPageChange={onPageChange}
                  template={paginationTemplate}
                />
              </div>
            </div>
          </div>
        </div>

        {openCreateModal && (
          <CreateModal
            toggleModal={setOpenCreateModal}
            getUsers={getUsers}
            roles={roles}
          />
        )}
        {openUpdateModal && (
          <UpdateModal
            toggleModal={setOpenUpdateModal}
            getUsers={getUsers}
            user={selectedUser}
            roles={roles}
          />
        )}
        {openDeleteModal && (
          <DeleteModal
            toggleModal={setOpenDeleteModal}
            getUsers={getUsers}
            user={selectedUser}
          />
        )}

        {openImportMahasiswaModal && (
          <ImportMahasiswaModal
            toggleModal={setOpenImportMahasiswaModal}
            getUsers={getUsers}
          />
        )}
        {openImportDosenModal && (
          <ImportDosenModal
            toggleModal={setOpenImportDosenModal}
            getUsers={getUsers}
          />
        )}
      </div>
    </div>
  ) : (
    <div>
      <div className="row">
        <div
          className="col-md-12 text-center align-center"
          style={{ marginTop: "20%" }}
        >
          <h1>Mohon Tunggu</h1>
        </div>
      </div>
    </div>
  );
};

export default Users;
